import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["parent", "child"]
  static values = { options: Object, prompt: String }

  connect() {
    this.updateChild()
  }

  updateChild() {
    const parentValue = this.parentTarget.value
    const childSelect = this.childTarget
    const currentValue = childSelect.value

    childSelect.disabled = !parentValue
    childSelect.innerHTML = ""

    const options = parentValue ? (this.optionsValue[parentValue] || []) : []

    if (this.promptValue) {
      const promptOption = document.createElement("option")
      promptOption.value = ""
      promptOption.textContent = this.promptValue
      childSelect.appendChild(promptOption)
    }

    options.forEach(([label, value]) => {
      const option = document.createElement("option")
      option.value = value
      option.textContent = label
      if (value === currentValue) option.selected = true
      childSelect.appendChild(option)
    })
  }
}
